import { toast } from "sonner";
import api from "@/lib/api";

function loadScript(src) {
  return new Promise((resolve) => {
    if (document.querySelector(`script[src="${src}"]`)) return resolve(true);
    const s = document.createElement("script");
    s.src = src;
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });
}

export async function payWithRazorpay(orderId, onSuccess) {
  const cfg = (await api.get("/payments/config")).data;
  if (!cfg.enabled) {
    toast.error("Online payments are not configured yet. Please pay manually — we'll confirm shortly.");
    return;
  }
  const ok = await loadScript("https://checkout.razorpay.com/v1/checkout.js");
  if (!ok || !window.Razorpay) {
    toast.error("Failed to load Razorpay. Check your internet.");
    return;
  }
  let rp;
  try {
    const { data } = await api.post(`/payments/create-order/${orderId}`);
    rp = data;
  } catch (e) {
    toast.error(e?.response?.data?.detail || "Could not initiate payment");
    return;
  }
  const options = {
    key: rp.key_id,
    amount: rp.amount,
    currency: rp.currency,
    name: "ScholarPrintHub",
    description: `Order ${rp.order_number}`,
    order_id: rp.razorpay_order_id,
    prefill: {
      name: rp.customer?.name || "",
      email: rp.customer?.email || "",
      contact: rp.customer?.mobile || "",
    },
    theme: { color: "#0A192F" },
    handler: async (response) => {
      try {
        const { data } = await api.post("/payments/verify", {
          razorpay_order_id: response.razorpay_order_id,
          razorpay_payment_id: response.razorpay_payment_id,
          razorpay_signature: response.razorpay_signature,
        });
        toast.success("Payment received!");
        if (onSuccess) onSuccess(data);
      } catch (err) {
        toast.error(err?.response?.data?.detail || "Payment verification failed");
      }
    },
    modal: {
      ondismiss: () => toast.info("Payment cancelled"),
    },
  };
  new window.Razorpay(options).open();
}
